import { Clock, File, MapPin, UsersRound } from "lucide-react";
import { cancelpost } from "../../services/Mainservice";
import "../../assets/Styles/Post.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader/Loader";

const CancelPosts = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [pagination, setpagination] = useState({ page: 1 });

  const navigate = useNavigate();

  useEffect(() => {
    getData("1");
  }, []);

  const getData = async () => {
    setloading(true);
    try {
      const response = await cancelpost();
      setData(response.data.data);
      setpagination(response.data.pagination);

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="data_head">
        <h1 className="data_heading">Cancelled Post</h1>
      </div>
      <div className="post_list">
        {data.length > 0 ? (
          <>
            {data?.map((item) => (
              <div className="post_card">
                <img src={item.image} className="post_card_image" />
                <p>
                  <span style={{ fontFamily: "bold" }}>{item.Title} </span>
                </p>
                {/* <p className="post_info_icon">Cancelled By</p> */}
                <p className="post_info_icon">
                  <img src={item.user.image} className="cancel_post_user" />
                  {item.user.FirstName}
                </p>
                <div className="post_info_icon">
                  <p className="post_info_icon">
                    <File
                      style={{
                        color: "var(--white)",
                        strokeWidth: "1.3px",
                        cursor: "pointer",
                      }}
                    />
                    {item.cancelReason}
                  </p>
                </div>
              </div>
            ))}
          </>
        ) : (
          <p className="nodata">No Post Canceled by User</p>
        )}
      </div>
      {loading && <Loader />}
    </>
  );
};
export default CancelPosts;
